// extracted by css-extract-rspack-plugin
export default {"cls1":"CtaIconLock-cls1_LTc","cls2":"CtaIconLock-cls2_Sik CtaIconLock-cls1_LTc"};